import React from "react";
import { Form, Button } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";

export function AddEditCiclosEscolares(props) {
  const { onRefetch, ciclo_escolar } = props;
  const { auth } = useAuth();

  const addCicloEscolar = async (data) => {
    try {
      await createCicloApi(data, auth.token);
      toast.success("Ciclo escolar creado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  const updateCiclo = async (id, data) => {
    try {
      await updateCicloApi(id, data, auth.token);
      toast.success("Ciclo escolar actualizado exitosamente");
    } catch (error) {
      throw error;
    }
  };

  async function createCicloApi(data, token) {
    try {
      let { fecha_inicio, fecha_fin } = data;
      fecha_inicio = sumarDias(fecha_inicio, 1);
      fecha_fin = sumarDias(fecha_fin, 1);
      const formattedFechaInicio = new Date(fecha_inicio)
        .toISOString()
        .split("T")[0];
      const formattedFechaFin = new Date(fecha_fin).toISOString().split("T")[0];

      const dataToSend = {
        ...data,
        fecha_inicio: formattedFechaInicio,
        fecha_fin: formattedFechaFin,
      };

      const url = `${BASE_API}/api/ciclo_escolar/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.post(url, dataToSend, { headers });
      return response.data;
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 400 || error.response.status === 500)
      ) {
        toast.error("El Ciclo escolar ya existe");
      }
      throw error;
    }
  }

  async function updateCicloApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/ciclo_escolar/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 400 || error.response.status === 500)
      ) {
        toast.error("El Ciclo escolar ya existe");
      }
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(ciclo_escolar),
    validationSchema: Yup.object(ciclo_escolar ? updateSchema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue, { resetForm }) => {
      try {
        // No sumar un día a las fechas para actualizaciones
        let { fecha_inicio, fecha_fin } = formValue;

        // Formatear las fechas solo si son instancias de Date
        const formattedFechaInicio =
          fecha_inicio instanceof Date
            ? new Date(fecha_inicio).toISOString().split("T")[0]
            : fecha_inicio;
        const formattedFechaFin =
          fecha_fin instanceof Date
            ? new Date(fecha_fin).toISOString().split("T")[0]
            : fecha_fin;

        const dataToSend = {
          ...formValue,
          fecha_inicio: formattedFechaInicio,
          fecha_fin: formattedFechaFin,
        };

        if (ciclo_escolar) {
          await updateCiclo(ciclo_escolar.id_ciclo_escolar, dataToSend);
        } else {
          await addCicloEscolar(dataToSend);
          resetForm();
        }
        onRefetch();
      } catch (error) {
        console.error(error);
      }
    },
  });

  // Función para sumar días a una fecha
  function sumarDias(fecha, dias) {
    const date = new Date(fecha);
    date.setDate(date.getDate() + dias);
    return date;
  }

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <div style={{ display: "flex" }}>
          <div style={{ width: "100%" }}>
            <label>Fecha Inicio de ciclo</label>
            <label className="astedisco">*</label>
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <div style={{ marginRight: "1rem", width: "100%" }}>
                <DatePicker
                  name="fecha_inicio"
                  placeholderText="dd/mm/aaaa"
                  selected={formik.values.fecha_inicio}
                  error={formik.errors.fecha_inicio}
                  onChange={(date) =>
                    formik.setFieldValue("fecha_inicio", date)
                  }
                  dateFormat="dd/MM/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
          </div>

          <div style={{ width: "100%" }}>
            <label>Fecha fin de ciclo</label>
            <label className="astedisco">*</label>
            <div style={{ display: "flex", marginBottom: "1rem" }}>
              <div style={{ marginRight: "1rem", width: "100%" }}>
                <DatePicker
                  name="fecha_fin"
                  placeholderText="dd/mm/aaaa"
                  selected={formik.values.fecha_fin}
                  error={formik.errors.fecha_fin ? true : false}
                  onChange={(date) => formik.setFieldValue("fecha_fin", date)}
                  dateFormat="dd/MM/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <Button
          type="submit"
          content={ciclo_escolar ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );

  function initialValues(datosCiclo) {
    return {
      fecha_inicio: datosCiclo?.fecha_inicio || null,
      fecha_fin: datosCiclo?.fecha_fin || null,
    };
  }
}

function newSchema() {
  return {
    fecha_inicio: Yup.date().required(),
    fecha_fin: Yup.date().required(),
  };
}

function updateSchema() {
  return {
    fecha_inicio: Yup.date().required(),
    fecha_fin: Yup.date().required(),
  };
}
